/* eslint-disable react/prop-types */
import React from "react";
import PropTypes from "prop-types";

// @material-ui/core
import withStyles from "@material-ui/core/styles/withStyles";
import MyLocation from "@material-ui/icons/MyLocation";
import FavoriteIcon from "@material-ui/icons/Favorite";
import WifiIcon from "@material-ui/icons/Wifi";
import AddIcon from "@material-ui/icons/Add";
import SignalWifiOff from "@material-ui/icons/SignalWifiOff";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";
import NotificationsIcon from "@material-ui/icons/Notifications";
import Box from "@material-ui/core/Box";
import Modal from "@material-ui/core/Modal";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";
import TablePagination from "@material-ui/core/TablePagination";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import TextField from "@material-ui/core/TextField";
import Chip from "@material-ui/core/Chip";

// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import Button from "components/CustomButtons/Button.jsx";

import MapLeft from "components/MapLeft/MapLeft.jsx";

import CustomSelect from "components/CustomSelect/CustomSelect.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";

import { convertIpToDecimal } from "../../utils/converters";

import {
  AVAILABLE_DEVICE_TYPES
} from "../../utils/deviceTypes.jsx";

import {
  getUserWidgets,
  getUserViews,
  getUserDevices,
  markDeviceFavorite,
  unmarkDeviceFavorite,
  createUserDevice,
  removeUserDevice,
  downloadDeviceData,
  startReprocessDeviceStatuses,
  getReprocessDeviceStatus
} from "../../services/dashboardDataProvider";

import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";

import deviceDefaultIcon from "assets/img/device-default.png";
import { MEDIA_ROOT } from "config.js";
import { dayjs } from "utils/time.jsx";

import "./Device.css";

let anchorEl = null;

const REPROCESS_TARGET_TYPE_OPTIONS = [
  { value: "device", label: "Device" },
  { value: "user", label: "User" },
  { value: "meter", label: "Meter" },
  { value: "alarm", label: "Alarm" },
  { value: "report", label: "Report" }
];

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      devices: [],
      favoriteDevices: [],
      addDeviceModalOpen: false,
      deviceAlias: null,
      deviceType: null,
      // Pagination state
      currentPage: 0,
      pageSize: 10,
      totalDevices: 0,
      // Controls state
      searchTerm: "",
      showMap: false,
      bulkReprocessModalOpen: false,
      bulkSelectedDevices: [],
      bulkReprocessMode: "day",
      bulkReprocessDay: dayjs().format("YYYY-MM-DD"),
      bulkReprocessStart: dayjs().startOf("day").format("YYYY-MM-DDTHH:mm"),
      bulkReprocessEnd: dayjs().format("YYYY-MM-DDTHH:mm"),
      bulkReprocessStatusIntervalMinutes: 10,
      bulkReprocessTargetTypes: REPROCESS_TARGET_TYPE_OPTIONS.map(option => option.value),
      bulkReprocessKeepExisting: false,
      bulkReprocessConfirming: false,
      bulkReprocessPreview: null,
      bulkReprocessSubmitting: false,
      bulkReprocessError: "",
      bulkReprocessResults: null,
      bulkReprocessCurrentDeviceLabel: "",
      bulkReprocessProgressMessage: "",
      bulkReprocessProgressPercent: 0,
      bulkReprocessCurrentProgress: null
    };
    this.markDeviceAsFavorite = this.markDeviceAsFavorite.bind(this);
  }

  componentWillUnmount() {
    clearTimeout(this.searchTimeout);
    this.clearBulkReprocessPollTimeout();
  }

  clearBulkReprocessPollTimeout = () => {
    if (this.bulkReprocessPollTimeout) {
      clearTimeout(this.bulkReprocessPollTimeout);
      this.bulkReprocessPollTimeout = null;
    }
  };

  setAnchorEl(el) {
    anchorEl = el;
  }

  handleMenuClick = idx => event => {
    this.setAnchorEl(event.currentTarget);
    this.setState({ selectedDev: idx });
  };

  onChange = (dictName, propName) => e => {
    const value = e.target.value;
    if (dictName == null || dictName === "") {
      this.setState({ [propName]: value });
    } else {
      let updatedData = this.state[dictName] || {};
      updatedData[propName] = value;
      this.setState({ [dictName]: updatedData });
    }
  };

  onSelectionChange = (dictName, propName) => value => {
    if (dictName == null || dictName === "") {
      this.setState({ [propName]: value });
    } else {
      let updatedData = this.state[dictName] || {};
      updatedData[propName] = value;
      this.setState({ [dictName]: updatedData });
    }
  };

  removeDevice = idx => {
    const devId = this.state.devices && this.state.devices[idx].id;
    if (window.confirm("Delete device ?")) {
      removeUserDevice(this.props.axios, devId).then(() => {
        this.fetchUserDevices();
      });
    }
  };

  downloadDeviceData() {
    let payload = this.state.downloadData || {};
    payload["exportType"] = "csv";
    downloadDeviceData(this.props.axios, "all", payload).then(data => {
      const blob = new Blob([data], { type: "text/csv" });
      // Creating an object for downloading url
      const url = window.URL.createObjectURL(blob);
      // Creating an anchor(a) tag of HTML
      const a = document.createElement("a");

      // Passing the blob downloading url
      a.setAttribute("href", url);

      // Setting the anchor tag attribute for downloading
      // and passing the download file name
      a.setAttribute("download", "all-devices-raw-data.csv");

      // Performing a download with click
      a.click();
      this.setState({ dataDownloadModalOpen: false });
    });
  }

  componentDidMount() {
    // eslint-disable-next-line react/prop-types
    getUserViews(this.props.axios, "List").then(data => {
      if (data.length > 0) {
        let viewConfig = {};
        data.forEach(dt => {
          if (dt.metadata && dt.metadata.device_list_view) {
            viewConfig = dt.metadata.device_list_view;
          }
        });
        this.setState({ viewConfig: viewConfig });
      }
    });
    this.fetchUserDevices();
    this.getFavoriteDevices();
  }

  fetchUserDevices() {
    const params = {
      page: this.state.currentPage + 1,
      page_size: this.state.pageSize,
      search_term: this.state.searchTerm
    };

    getUserDevices(this.props.axios, params).then(data => {
      const nextDevices = data.devices
        .map(dev => {
          return { ...dev, ipNum: convertIpToDecimal(dev.ip_address) };
        })
        .sort((d1, d2) => d1.ipNum - d2.ipNum);
      this.setState({
        devices: nextDevices,
        bulkSelectedDevices: (this.state.bulkSelectedDevices || []).filter(id =>
          nextDevices.some(device => device.ip_address === id)
        ),
        totalDevices: data.total_count || data.devices.length
      });
    });
  }

  isAdminUser() {
    const user = this.props.user || {};
    return user.isAdmin === true || user.isSuperuser === true;
  }

  addNewDevice() {
    const data = {
      device_name: this.state.deviceAlias,
      device_type: this.state.deviceType
    };
    createUserDevice(this.props.axios, data).then(_ => {
      this.setState({ addDeviceModalOpen: false });
      this.fetchUserDevices();
    });
  }

  getFavoriteDevices() {
    getUserWidgets(this.props.axios).then(data => {
      let favoriteWidget = data.results.find(
        widgetData => widgetData.widget.name === "Favorite Devices"
      );
      const favoriteDevicesRaw =
        (favoriteWidget &&
          favoriteWidget.metadata &&
          favoriteWidget.metadata.favorite_devices) ||
        [];
      const favoriteDevices = favoriteDevicesRaw
        .filter(deviceId => deviceId !== null && deviceId !== undefined)
        .map(deviceId => String(deviceId));
      this.setState({ favoriteDevices: favoriteDevices });
    });
  }

  markDeviceAsFavorite = (device, markFavorite) => e => {
    if (markFavorite) {
      markDeviceFavorite(this.props.axios, device.ip_address).then(_ =>
        this.getFavoriteDevices()
      );
    } else {
      unmarkDeviceFavorite(this.props.axios, device.ip_address).then(_ =>
        this.getFavoriteDevices()
      );
    }
  };

  handlePageChange = (event, newPage) => {
    this.setState({ currentPage: newPage }, () => {
      this.fetchUserDevices();
    });
  };

  handlePageSizeChange = event => {
    const newPageSize = parseInt(event.target.value, 10);
    this.setState(
      {
        pageSize: newPageSize,
        currentPage: 0
      },
      () => {
        this.fetchUserDevices();
      }
    );
  };

  handleSearchChange = event => {
    const searchTerm = event.target.value;
    this.setState({ searchTerm }, () => {
      // Debounce search to avoid too many API calls
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.fetchUserDevices();
      }, 500);
    });
  };

  handleMapVisibilityChange = event => {
    this.setState({ showMap: event.target.checked });
  };

  openBulkReprocessModal = () => {
    this.setState({
      bulkReprocessModalOpen: true,
      bulkReprocessError: "",
      bulkReprocessResults: null,
      bulkReprocessConfirming: false,
      bulkReprocessPreview: null,
      bulkSelectedDevices:
        this.state.bulkSelectedDevices && this.state.bulkSelectedDevices.length > 0
          ? this.state.bulkSelectedDevices
          : (this.state.devices || []).map(device => device.ip_address)
    });
  };

  closeBulkReprocessModal = () => {
    if (this.state.bulkReprocessSubmitting) return;
    this.clearBulkReprocessPollTimeout();
    this.setState({
      bulkReprocessModalOpen: false,
      bulkReprocessError: "",
      bulkReprocessConfirming: false,
      bulkReprocessPreview: null,
      bulkReprocessCurrentDeviceLabel: "",
      bulkReprocessProgressMessage: "",
      bulkReprocessProgressPercent: 0,
      bulkReprocessCurrentProgress: null
    });
  };

  waitForReprocessJob = (deviceId, jobId, onProgress) =>
    new Promise((resolve, reject) => {
      const poll = async () => {
        try {
          const job = await getReprocessDeviceStatus(this.props.axios, deviceId, jobId);
          if (onProgress) {
            onProgress(job);
          }

          if (job.status === "completed") {
            this.clearBulkReprocessPollTimeout();
            resolve(job.result || null);
            return;
          }

          if (job.status === "failed") {
            this.clearBulkReprocessPollTimeout();
            const error = new Error(
              job.error || job.message || "Failed to reprocess statuses."
            );
            error.job = job;
            reject(error);
            return;
          }

          this.clearBulkReprocessPollTimeout();
          this.bulkReprocessPollTimeout = setTimeout(poll, 1500);
        } catch (error) {
          this.clearBulkReprocessPollTimeout();
          reject(error);
        }
      };

      poll();
    });

  resetBulkReprocessReview = patch => {
    this.setState({
      ...patch,
      bulkReprocessError: "",
      bulkReprocessConfirming: false,
      bulkReprocessPreview: null,
      bulkReprocessResults: null
    });
  };

  toggleBulkDeviceSelection = deviceId => () => {
    const selectedDevices = new Set(this.state.bulkSelectedDevices || []);
    if (selectedDevices.has(deviceId)) {
      selectedDevices.delete(deviceId);
    } else {
      selectedDevices.add(deviceId);
    }
    this.resetBulkReprocessReview({
      bulkSelectedDevices: Array.from(selectedDevices)
    });
  };

  selectAllVisibleDevices = () => {
    this.resetBulkReprocessReview({
      bulkSelectedDevices: (this.state.devices || []).map(device => device.ip_address)
    });
  };

  clearBulkDeviceSelection = () => {
    this.resetBulkReprocessReview({ bulkSelectedDevices: [] });
  };

  toggleBulkTargetTypeSelection = targetType => () => {
    const selectedTargetTypes = new Set(this.state.bulkReprocessTargetTypes || []);
    if (selectedTargetTypes.has(targetType)) {
      selectedTargetTypes.delete(targetType);
    } else {
      selectedTargetTypes.add(targetType);
    }

    this.resetBulkReprocessReview({
      bulkReprocessTargetTypes: Array.from(selectedTargetTypes)
    });
  };

  getBulkReprocessRequestDetails = () => {
    const selectedDevices = (this.state.devices || []).filter(device =>
      (this.state.bulkSelectedDevices || []).includes(device.ip_address)
    );

    if (selectedDevices.length === 0) {
      return { error: "Select at least one device to reprocess." };
    }

    const selectedTargetTypes = this.state.bulkReprocessTargetTypes || [];
    if (selectedTargetTypes.length === 0) {
      return { error: "Choose at least one status target to reprocess." };
    }

    const payload = {
      mode: this.state.bulkReprocessMode,
      keep_existing_statuses: this.state.bulkReprocessKeepExisting,
      status_interval_minutes: this.state.bulkReprocessStatusIntervalMinutes,
      target_types: selectedTargetTypes
    };

    const intervalMinutes = parseInt(this.state.bulkReprocessStatusIntervalMinutes, 10);
    if (Number.isNaN(intervalMinutes) || intervalMinutes < 2 || intervalMinutes > 60) {
      return { error: "Status interval must be between 2 and 60 minutes." };
    }

    if (this.state.bulkReprocessMode === "range") {
      const start = dayjs(this.state.bulkReprocessStart);
      const end = dayjs(this.state.bulkReprocessEnd);

      if (!start.isValid() || !end.isValid()) {
        return { error: "Start and end time must be valid values." };
      }
      if (!end.isAfter(start)) {
        return { error: "End time must be later than start time." };
      }

      payload.start = start.toISOString();
      payload.end = end.toISOString();

      return {
        payload,
        selectedDevices,
        preview: [
          `Devices selected: ${selectedDevices.length}`,
          `Status interval: ${intervalMinutes} minute${intervalMinutes === 1 ? "" : "s"}`,
          `Targets: ${selectedTargetTypes.join(", ")}`,
          `Start: ${start.format("YYYY-MM-DD HH:mm")} (${start.toISOString()})`,
          `End: ${end.format("YYYY-MM-DD HH:mm")} (${end.toISOString()})`,
          this.state.bulkReprocessKeepExisting
            ? "Existing status rows will be kept for every selected device."
            : "Existing status rows in this window will be deleted and rebuilt for every selected device."
        ]
      };
    }

    if (!this.state.bulkReprocessDay) {
      return { error: "Choose a device-local day to reprocess." };
    }

    payload.day = this.state.bulkReprocessDay;
    return {
      payload,
      selectedDevices,
      preview: [
        `Devices selected: ${selectedDevices.length}`,
        `Status interval: ${intervalMinutes} minute${intervalMinutes === 1 ? "" : "s"}`,
        `Targets: ${selectedTargetTypes.join(", ")}`,
        `Day: ${this.state.bulkReprocessDay}`,
        "Replay will use each device timezone for the selected day.",
        this.state.bulkReprocessKeepExisting
          ? "Existing status rows will be kept for every selected device."
          : "Existing status rows for that day will be deleted and rebuilt for every selected device."
      ]
    };
  };

  reviewBulkReprocess = () => {
    const details = this.getBulkReprocessRequestDetails();
    if (details.error) {
      this.setState({
        bulkReprocessError: details.error,
        bulkReprocessConfirming: false,
        bulkReprocessPreview: null
      });
      return;
    }

    const deviceLabels = details.selectedDevices
      .slice(0, 5)
      .map(device => device.alias || device.ip_address);
    const remainingCount = details.selectedDevices.length - deviceLabels.length;
    const preview = [...details.preview, `Targets: ${deviceLabels.join(", ")}${remainingCount > 0 ? ` + ${remainingCount} more` : ""}`];

    this.setState({
      bulkReprocessError: "",
      bulkReprocessResults: null,
      bulkReprocessConfirming: true,
      bulkReprocessPreview: preview
    });
  };

  submitBulkReprocess = async () => {
    const details = this.getBulkReprocessRequestDetails();
    if (details.error) {
      this.setState({
        bulkReprocessError: details.error,
        bulkReprocessConfirming: false,
        bulkReprocessPreview: null
      });
      return;
    }

    this.setState({
      bulkReprocessSubmitting: true,
      bulkReprocessError: "",
      bulkReprocessResults: null,
      bulkReprocessCurrentDeviceLabel: "",
      bulkReprocessProgressMessage: "",
      bulkReprocessProgressPercent: 0,
      bulkReprocessCurrentProgress: null
    });

    const results = [];
    for (const device of details.selectedDevices) {
      const deviceLabel = device.alias || device.ip_address;
      try {
        this.setState({
          bulkReprocessCurrentDeviceLabel: deviceLabel,
          bulkReprocessProgressMessage: `Queueing replay for ${deviceLabel}...`,
          bulkReprocessProgressPercent: 0,
          bulkReprocessCurrentProgress: null
        });

        const job = await startReprocessDeviceStatuses(
          this.props.axios,
          device.ip_address,
          details.payload
        );

        const response = await this.waitForReprocessJob(
          device.ip_address,
          job.job_id,
          jobState => {
            this.setState({
              bulkReprocessCurrentDeviceLabel: deviceLabel,
              bulkReprocessProgressMessage:
                jobState.message || `Running replay for ${deviceLabel}...`,
              bulkReprocessProgressPercent: jobState.progress_percent || 0,
              bulkReprocessCurrentProgress: jobState.progress || null
            });
          }
        );

        results.push({
          deviceId: device.ip_address,
          deviceLabel: deviceLabel,
          success: true,
          message: response.message,
          deletedStatusCount: response.deleted_status_count || 0,
          replayedRawCount: response.replayed_raw_count || 0,
          totalRawCount: response.total_raw_count || 0
        });
      } catch (error) {
        results.push({
          deviceId: device.ip_address,
          deviceLabel: deviceLabel,
          success: false,
          message:
            (error.job && (error.job.error || error.job.message)) ||
            (error.response &&
              error.response.data &&
              (error.response.data.error || error.response.data.detail)) ||
            error.message ||
            "Failed to reprocess statuses."
        });
      }
    }

    this.setState({
      bulkReprocessSubmitting: false,
      bulkReprocessConfirming: false,
      bulkReprocessResults: results,
      bulkReprocessCurrentDeviceLabel: "",
      bulkReprocessProgressMessage: "",
      bulkReprocessProgressPercent: 0,
      bulkReprocessCurrentProgress: null
    });
    this.fetchUserDevices();
  };

  renderDeviceCompact(deviceData, idx) {
    const { classes } = this.props;
    const timeNow = dayjs();
    const lastDataSyncTime =
      deviceData.other_data && deviceData.other_data.last_data_sync_time;
    const isDeviceActive =
      lastDataSyncTime && timeNow.diff(dayjs(lastDataSyncTime), "days") < 1
        ? true
        : false;
    const hasNotifications = false;

    const isFavoriteDev = this.state.favoriteDevices.includes(
      String(deviceData.id)
    );

    const deviceType = deviceData.type;

    let tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

    return (
      <div className="deviceCompactViewContainer">
        <div className="deviceDetailsContainer">
          <div>
            Type: <b>{deviceData.type}</b>
          </div>
          <div>
            Last Updated:{" "}
            <b>
              {lastDataSyncTime
                ? dayjs(lastDataSyncTime).format("D-MM-YYYY, hh:mm")
                : "Unknown"}
            </b>
            <small>({tz})</small>
          </div>
        </div>
        <div className="deviceDetailsIconsContainer">
          <div className="deviceActionsContainer">
            <h6 className="deviceAlias">{deviceData.alias}</h6>
            <IconButton className="deviceActionsMenuButton">
              <MoreVertIcon onClick={this.handleMenuClick(idx)} />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={this.state.selectedDev === idx}
              onClose={() => this.setState({ selectedDev: null })}
            >
              <MenuItem onClick={() => this.removeDevice(idx)}>Remove</MenuItem>
            </Menu>
          </div>
          <div className="devStatusIconsContainer">
            <FavoriteIcon
              className="devStatusIcon"
              color={isFavoriteDev === true ? "primary" : "disabled"}
              onClick={this.markDeviceAsFavorite(
                deviceData,
                isFavoriteDev === false
              )}
            />
            {isDeviceActive ? (
              <WifiIcon className="devStatusIcon" color="primary" />
            ) : (
              <SignalWifiOff className="devStatusIcon" color="disabled" />
            )}
            {hasNotifications ? (
              <NotificationsActiveIcon
                className="devStatusIcon"
                color="primary"
              />
            ) : (
              <NotificationsIcon className="devStatusIcon" color="disabled" />
            )}
          </div>
        </div>
        <div className="actionButtonsContainer">
          <Button
            round={true}
            size="sm"
            color="info"
            className={classes.marginRight}
            onClick={e =>
              this.props.history.push(`devicedetails/${deviceData.ip_address}`)
            }
          >
            Details
          </Button>
          <Button
            round={true}
            size="sm"
            color="info"
            className={classes.marginRight}
            onClick={e =>
              this.props.history.push(`devicereports/${deviceData.ip_address}`)
            }
          >
            Report
          </Button>
        </div>
      </div>
    );
  }

  renderDevice(deviceData, idx) {
    // eslint-disable-next-line no-unused-vars
    const { classes } = this.props;
    const timeNow = dayjs();
    const lastDataSyncTime =
      deviceData.other_data && deviceData.other_data.last_data_sync_time;
    const isDeviceActive =
      lastDataSyncTime && timeNow.diff(dayjs(lastDataSyncTime), "days") < 1
        ? true
        : false;
    const hasNotifications = false;

    const isFavoriteDev = this.state.favoriteDevices.includes(
      String(deviceData.id)
    );

    let deviceAvatar = deviceDefaultIcon;
    if (deviceData.face != null) {
      deviceAvatar = `${MEDIA_ROOT}${deviceData.face}`;
    }
    let deviceType = deviceData.type;

    return (
      <Card>
        <CardHeader color="info" stats icon>
          <CardIcon color="info" className={classes.deviceSummaryCardIcon}>
            <img src={deviceAvatar} alt="face" width="200px" height="150px" />
          </CardIcon>
          <div className={classes.cardCategory}>
            <h6 className="deviceAlias">{deviceData.alias}</h6>
          </div>
          <div className="deviceDetailsIconsContainer">
            <div className="devStatusIconsContainer">
              <FavoriteIcon
                className="devStatusIcon"
                color={isFavoriteDev === true ? "primary" : "disabled"}
                onClick={this.markDeviceAsFavorite(
                  deviceData,
                  isFavoriteDev === false
                )}
              />
              {isDeviceActive ? (
                <WifiIcon className="devStatusIcon" color="primary" />
              ) : (
                <SignalWifiOff className="devStatusIcon" color="disabled" />
              )}
              {hasNotifications ? (
                <NotificationsActiveIcon
                  className="devStatusIcon"
                  color="primary"
                />
              ) : (
                <NotificationsIcon className="devStatusIcon" color="disabled" />
              )}
              <IconButton className="deviceActionsMenuButton">
                <MoreVertIcon
                  className="deviceActionsMenuIcon"
                  onClick={this.handleMenuClick(idx)}
                />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={this.state.selectedDev === idx}
                onClose={() => this.setState({ selectedDev: null })}
              >
                <MenuItem onClick={() => this.removeDevice(idx)}>
                  Remove
                </MenuItem>
              </Menu>
            </div>
          </div>
        </CardHeader>
        <CardBody>
          <div className="deviceDetailsContainer">
            <div>
              IP Address: <b>{deviceData.ip_address}</b>
            </div>
            <div>
              Type: <b>{deviceData.type}</b>
            </div>
            <div>
              Last Updated:{" "}
              <b>
                {lastDataSyncTime
                  ? dayjs(lastDataSyncTime).format("D-MM-YYYY, hh:mm")
                  : "Unknown"}
              </b>
            </div>
          </div>
        </CardBody>
        <CardFooter stats>
          <GridContainer>
            <div className={"deviceLocationContainer"} xs={12} sm={12} md={12}>
              <MyLocation /> {deviceData.address}
            </div>
            <div className="actionButtonsContainer">
              <Button
                color="info"
                size="sm"
                className={classes.marginRight}
                onClick={e =>
                  this.props.history.push(
                    `devicedetails/${deviceData.ip_address}`
                  )
                }
              >
                Details
              </Button>
              <Button
                color="info"
                size="sm"
                className={classes.marginRight}
                onClick={e =>
                  this.props.history.push(
                    `devicereports/${deviceData.ip_address}`
                  )
                }
              >
                Report
              </Button>
            </div>
          </GridContainer>
        </CardFooter>
      </Card>
    );
  }

  renderDevices() {
    const { viewConfig } = this.state;
    const isCompactView = viewConfig && viewConfig.compact === true;
    return (
      <GridContainer>
        {this.state.devices &&
          this.state.devices.map((deviceData, idx) => {
            return (
              <GridItem xs={12} sm={12} md={6} key={`widget-${deviceData.id}`}>
                {!isCompactView
                  ? this.renderDevice(deviceData, idx)
                  : this.renderDeviceCompact(deviceData, idx)}
              </GridItem>
            );
          })}
      </GridContainer>
    );
  }

  median(values) {
    if (values.length === 0) {
      throw new Error("Input array is empty");
    }

    // Sorting values, preventing original array
    // from being mutated.
    values = [...values].sort((a, b) => a - b);

    const half = Math.floor(values.length / 2);

    return values.length % 2
      ? values[half]
      : (values[half - 1] + values[half]) / 2;
  }

  renderDevicesMap() {
    let zoom = 2;
    let center = [52.5103175, 13.3275342];
    let minLat = null,
      minLong = null;
    let maxLat = null,
      maxLong = null;
    let dataPoints = [];
    this.state.devices &&
      this.state.devices.forEach(deviceData => {
        if (deviceData.lat && deviceData.long) {
          let lat = parseFloat(deviceData.lat);
          let lng = parseFloat(deviceData.long);
          dataPoints.push({
            latitude: lat,
            longitude: lng,
            name: deviceData.alias,
            url: deviceData.url
          });
          if (minLat == null || lat < minLat) {
            minLat = lat;
          }
          if (minLong == null || lng < minLong) {
            minLong = lng;
          }
          if (maxLat == null || lat > maxLat) {
            maxLat = lat;
          }
          if (maxLong == null || lng > maxLong) {
            maxLong = lng;
          }
        }
      });
    if (dataPoints.length > 0) {
      center = [
        this.median(dataPoints.map(dp => dp.latitude)),
        this.median(dataPoints.map(dp => dp.longitude))
      ];
      zoom = Math.abs(maxLat - minLat) + Math.abs(maxLong - minLong);
      zoom = (zoom * 7) % 13;
    }
    return (
      <GridContainer>
        <MapLeft center={center} dataPoints={dataPoints} zoom={zoom} />
      </GridContainer>
    );
  }

  renderDeviceCreation() {
    const { classes } = this.props;
    let availableStatusTypes = [{ value: "raw_data", text: "Raw Data" }];
    const downloadData = this.state.downloadData || {};
    const selectedCount = (this.state.bulkSelectedDevices || []).length;
    return (
      <div className="addDeviceButtonContainer">
        <Button
          color="info"
          size="sm"
          className={classes.marginRight}
          onClick={e => this.setState({ addDeviceModalOpen: true })}
        >
          <AddIcon className="devStatusIcon" color="warning" /> Add new device
        </Button>
        <Button
          color="info"
          size="sm"
          className={classes.marginRight}
          onClick={() => this.setState({ dataDownloadModalOpen: true })}
        >
          Download Data
        </Button>
        {this.isAdminUser() ? (
          <Button
            color="info"
            size="sm"
            className={classes.marginRight}
            onClick={this.openBulkReprocessModal}
          >
            Reprocess Statuses{selectedCount > 0 ? ` (${selectedCount})` : ""}
          </Button>
        ) : null}
        <Modal
          hideBackdrop
          open={this.state.addDeviceModalOpen}
          onClose={e => this.setState({ addDeviceModalOpen: false })}
          aria-labelledby="Add"
          aria-describedby="Add new device"
        >
          <Box className="deviceModalBox">
            <div className="deviceSelectionContainer">
              <span className={classes.chartTypeLabel}>Device Name</span>
              <CustomInput
                className="deviceInputField"
                key="dev-alias-input"
                id="alias"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.deviceAlias || "",
                  onChange: this.onChange(null, "deviceAlias")
                }}
              />
            </div>
            <div className="deviceSelectionContainer">
              <span className={classes.chartTypeLabel}>Device Type</span>
              <CustomSelect
                className="deviceInputField"
                items={AVAILABLE_DEVICE_TYPES}
                onChange={this.onSelectionChange(null, "deviceType")}
              />
            </div>
            <div className="deviceSelectionContainer">
              <Button
                color="info"
                size="sm"
                disabled={!(this.state.deviceType && this.state.deviceAlias)}
                onClick={e => this.addNewDevice()}
              >
                Add
              </Button>
              <Button
                size="sm"
                onClick={e => this.setState({ addDeviceModalOpen: false })}
              >
                Cancel
              </Button>
            </div>
          </Box>
        </Modal>
        <Modal
          hideBackdrop
          open={this.state.bulkReprocessModalOpen}
          onClose={this.closeBulkReprocessModal}
          aria-labelledby="Bulk Reprocess"
          aria-describedby="Bulk reprocess device statuses"
        >
          <Box className="deviceModalBox">
            <div className="deviceSelectionContainer">
              <label className={classes.chartTypeLabel}>Devices</label>
              <div className="bulkDeviceActionsRow">
                <Button size="sm" onClick={this.selectAllVisibleDevices}>
                  Select visible
                </Button>
                <Button size="sm" onClick={this.clearBulkDeviceSelection}>
                  Clear
                </Button>
              </div>
            </div>
            <div className="bulkDeviceChipRow">
              {(this.state.devices || []).map(device => {
                const selected = (this.state.bulkSelectedDevices || []).includes(
                  device.ip_address
                );
                return (
                  <Chip
                    key={`bulk-device-${device.ip_address}`}
                    clickable
                    color={selected ? "primary" : "default"}
                    variant={selected ? "default" : "outlined"}
                    className="bulkDeviceChip"
                    label={device.alias || device.ip_address}
                    onClick={this.toggleBulkDeviceSelection(device.ip_address)}
                  />
                );
              })}
            </div>

            <div className="deviceSelectionContainer">
              <label className={classes.chartTypeLabel}>Scope</label>
              <div className="bulkDeviceActionsRow">
                <Chip
                  clickable
                  color={this.state.bulkReprocessMode === "day" ? "primary" : "default"}
                  variant={this.state.bulkReprocessMode === "day" ? "default" : "outlined"}
                  label="Device-local day"
                  onClick={() =>
                    this.resetBulkReprocessReview({ bulkReprocessMode: "day" })
                  }
                />
                <Chip
                  clickable
                  color={this.state.bulkReprocessMode === "range" ? "primary" : "default"}
                  variant={this.state.bulkReprocessMode === "range" ? "default" : "outlined"}
                  label="Exact time range"
                  onClick={() =>
                    this.resetBulkReprocessReview({ bulkReprocessMode: "range" })
                  }
                />
              </div>
            </div>

            <div className="deviceSelectionContainer">
              <label className={classes.chartTypeLabel}>Targets</label>
              <div className="bulkDeviceActionsRow">
                {REPROCESS_TARGET_TYPE_OPTIONS.map(option => {
                  const selected = (this.state.bulkReprocessTargetTypes || []).includes(
                    option.value
                  );
                  return (
                    <Chip
                      key={`bulk-target-${option.value}`}
                      clickable
                      color={selected ? "primary" : "default"}
                      variant={selected ? "default" : "outlined"}
                      label={option.label}
                      onClick={this.toggleBulkTargetTypeSelection(option.value)}
                    />
                  );
                })}
              </div>
            </div>

            <div className="deviceSelectionContainer">
              <CustomInput
                labelText="Status interval (minutes)"
                formControlProps={{ fullWidth: true }}
                inputProps={{
                  type: "number",
                  min: 2,
                  max: 60,
                  value: this.state.bulkReprocessStatusIntervalMinutes || 10,
                  onChange: e =>
                    this.resetBulkReprocessReview({
                      bulkReprocessStatusIntervalMinutes: e.target.value
                    })
                }}
              />
            </div>

            <div className="deviceSelectionContainer">
              {this.state.bulkReprocessMode === "day" ? (
                <CustomInput
                  labelText="Day"
                  formControlProps={{ fullWidth: true }}
                  inputProps={{
                    type: "date",
                    value: this.state.bulkReprocessDay || "",
                    onChange: e =>
                      this.resetBulkReprocessReview({
                        bulkReprocessDay: e.target.value
                      })
                  }}
                />
              ) : (
                <div className="bulkDateRangeRow">
                  <CustomInput
                    labelText="Start"
                    formControlProps={{ fullWidth: true }}
                    inputProps={{
                      type: "datetime-local",
                      value: this.state.bulkReprocessStart || "",
                      onChange: e =>
                        this.resetBulkReprocessReview({
                          bulkReprocessStart: e.target.value
                        })
                    }}
                  />
                  <CustomInput
                    labelText="End"
                    formControlProps={{ fullWidth: true }}
                    inputProps={{
                      type: "datetime-local",
                      value: this.state.bulkReprocessEnd || "",
                      onChange: e =>
                        this.resetBulkReprocessReview({
                          bulkReprocessEnd: e.target.value
                        })
                    }}
                  />
                </div>
              )}
            </div>

            <div className="deviceSelectionContainer">
              <FormControlLabel
                control={
                  <Switch
                    checked={this.state.bulkReprocessKeepExisting === true}
                    onChange={event =>
                      this.resetBulkReprocessReview({
                        bulkReprocessKeepExisting: event.target.checked
                      })
                    }
                    color="primary"
                  />
                }
                label="Keep existing status rows"
              />
            </div>

            {this.state.bulkReprocessPreview ? (
              <div className="bulkSummaryCard">
                {this.state.bulkReprocessPreview.map((line, idx) => (
                  <div key={`bulk-preview-${idx}`} className="bulkSummaryLine">
                    {line}
                  </div>
                ))}
              </div>
            ) : null}

            {this.state.bulkReprocessError ? (
              <div className="bulkErrorText">{this.state.bulkReprocessError}</div>
            ) : null}

            {this.state.bulkReprocessSubmitting ? (
              <div className="bulkSummaryCard">
                <div className="bulkSummaryLine">
                  Running: {this.state.bulkReprocessCurrentDeviceLabel || "Preparing replay"}
                </div>
                <div className="bulkSummaryLine">
                  {this.state.bulkReprocessProgressMessage || "Replay is running..."}
                </div>
                <div className="bulkSummaryLine">
                  Progress: {this.state.bulkReprocessProgressPercent || 0}%
                </div>
                <div className="bulkSummaryLine">
                  Visited raws: {((this.state.bulkReprocessCurrentProgress || {}).processed_raw_count) || 0} / {((this.state.bulkReprocessCurrentProgress || {}).total_raw_count) || 0}
                </div>
              </div>
            ) : null}

            {this.state.bulkReprocessResults ? (
              <div className="bulkSummaryCard">
                {this.state.bulkReprocessResults.map(result => (
                  <div key={result.deviceId} className="bulkResultsItem">
                    <strong>{result.deviceLabel}</strong>: {result.message}
                    {result.success
                      ? ` Replayed ${result.replayedRawCount} raws out of ${result.totalRawCount}, deleted ${result.deletedStatusCount} statuses.`
                      : ""}
                  </div>
                ))}
              </div>
            ) : null}

            <div className="deviceSelectionContainer">
              <Button
                size="sm"
                onClick={this.closeBulkReprocessModal}
                disabled={this.state.bulkReprocessSubmitting === true}
              >
                Close
              </Button>
              <Button
                size="sm"
                color="info"
                onClick={
                  this.state.bulkReprocessConfirming
                    ? this.submitBulkReprocess
                    : this.reviewBulkReprocess
                }
                disabled={this.state.bulkReprocessSubmitting === true}
              >
                {this.state.bulkReprocessSubmitting
                  ? "Reprocessing..."
                  : this.state.bulkReprocessConfirming
                  ? "Confirm and Run"
                  : "Review Reprocess"}
              </Button>
            </div>
          </Box>
        </Modal>
        <Modal
          hideBackdrop
          open={this.state.dataDownloadModalOpen}
          onClose={() => this.setState({ dataDownloadModalOpen: false })}
          aria-labelledby="Download"
          aria-describedby="Download Data"
        >
          <Box className="deviceModalBox">
            <div className="deviceSelectionContainer">
              <label className={classes.chartTypeLabel}>Data Type</label>
              <CustomSelect
                className={classes.alarmTypeSelector}
                labelText={this.state.selectedAlarmType}
                items={availableStatusTypes}
                onChange={this.onSelectionChange("downloadData", "dataType")}
              />
            </div>
            <div className="deviceSelectionContainer">
              <CustomInput
                labelText="Start Date"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  type: "date",
                  value: downloadData.startDate,
                  onChange: this.onChange("downloadData", "startDate")
                }}
              />
            </div>
            <div className="deviceSelectionContainer">
              <CustomInput
                labelText="End Date"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  type: "date",
                  value: downloadData.endDate,
                  onChange: this.onChange("downloadData", "endDate")
                }}
              />
            </div>
            <div className="deviceSelectionContainer">
              <Button size="sm" onClick={() => this.downloadDeviceData()}>
                Download
              </Button>
              <Button
                size="sm"
                onClick={() => this.setState({ dataDownloadModalOpen: false })}
              >
                Cancel
              </Button>
            </div>
          </Box>
        </Modal>
      </div>
    );
  }

  render() {
    // eslint-disable-next-line no-unused-vars
    const { classes } = this.props;
    const { currentPage, pageSize, totalDevices } = this.state;

    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <TextField
                    label="Search devices"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={this.state.searchTerm}
                    onChange={this.handleSearchChange}
                    placeholder="Search by name, IP, or type..."
                  />
                </GridItem>
                <GridItem xs={12} sm={6} md={4}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={this.state.showMap}
                        onChange={this.handleMapVisibilityChange}
                        color="primary"
                      />
                    }
                    label="Show Map"
                  />
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
        {this.state.showMap && (
          <GridItem xs={12} sm={12} md={12}>
            {this.renderDevicesMap()}
          </GridItem>
        )}
        <GridItem xs={12} sm={12} md={12}>
          {this.renderDeviceCreation()}
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          {this.renderDevices()}
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <TablePagination
            component="div"
            count={totalDevices}
            page={currentPage}
            onChangePage={this.handlePageChange}
            rowsPerPage={pageSize}
            onChangeRowsPerPage={this.handlePageSizeChange}
            rowsPerPageOptions={[5, 10, 25, 50]}
            labelRowsPerPage="Devices per page:"
            labelDisplayedRows={({ from, to, count }) =>
              `${from}-${to} of ${
                count !== -1 ? count : `more than ${to}`
              } devices`
            }
          />
        </GridItem>
      </GridContainer>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(dashboardStyle)(Dashboard);
